/**
 * SENIQ Trail System Kit Card
 * Handles sibling color swaps + size selection
 * Single "Add to Bag" button adds all kit items at once
 */

(function () {
  'use strict';

  function initKitCards() {
    const kitWrap = document.querySelector('[data-kit-wrap]');
    if (!kitWrap) return;

    const cards = kitWrap.querySelectorAll('[data-kit-card]');
    if (!cards.length) return;

    const atcBtn = kitWrap.querySelector('[data-kit-atc]');
    const atcText = kitWrap.querySelector('[data-kit-atc-text]');

    // Per-card state: { cardIndex: { siblingId, variantId } }
    const cardState = {};

    cards.forEach((card, cardIndex) => {
      const siblingDataEl = card.querySelector('[data-kit-siblings]');
      if (!siblingDataEl) return;

      let siblings;
      try {
        siblings = JSON.parse(siblingDataEl.textContent);
      } catch (e) {
        console.error('SENIQ Kit: could not parse sibling data', e);
        return;
      }

      let activeSiblingId = siblings[0].id;
      let activeSize = null;

      // ── Swatch clicks ────────────────────────────────────────────────────
      card.querySelectorAll('[data-kit-swatch]').forEach(swatch => {
        swatch.addEventListener('click', () => {
          const sibId = parseInt(swatch.dataset.kitSwatch, 10);
          const sibling = siblings.find(s => s.id === sibId);
          if (!sibling) return;

          activeSiblingId = sibId;

          card.querySelectorAll('[data-kit-swatch]').forEach(s => s.classList.remove('is-active'));
          swatch.classList.add('is-active');

          // Swap image
          const swapImg = card.querySelector('[data-kit-swap-image]');
          const baseImg = card.querySelector('.kit-card__base-image');
          if (swapImg && sibling.image) {
            swapImg.src = sibling.image;
            swapImg.style.display = 'block';
            if (baseImg) baseImg.style.opacity = '0';
          }

          // Update color label
          const colorLabel = card.querySelector('[data-kit-selected-color]');
          if (colorLabel) colorLabel.textContent = swatch.title;

          // Update links
          const imageLink = card.querySelector('[data-kit-image-link]');
          const titleLink = card.querySelector('[data-kit-title-link]');
          if (imageLink) imageLink.href = sibling.url;
          if (titleLink) {
            titleLink.href = sibling.url;
            titleLink.textContent = sibling.title;
          }

          updateSizeAvailability(card, sibling, activeSize);

          // Reset size selection if switching color
          activeSize = null;
          card.querySelectorAll('[data-size]').forEach(s => s.classList.remove('is-active'));
          delete cardState[cardIndex];
          updateStatus(card, null);
          updateKitButton(cards, cardState, atcBtn, atcText);
        });
      });

      // ── Size clicks ──────────────────────────────────────────────────────
      card.querySelectorAll('[data-size]').forEach(sizeBtn => {
        sizeBtn.addEventListener('click', () => {
          if (sizeBtn.classList.contains('is-unavailable')) return;

          activeSize = sizeBtn.dataset.size;

          card.querySelectorAll('[data-size]').forEach(s => s.classList.remove('is-active'));
          sizeBtn.classList.add('is-active');

          const sibling = siblings.find(s => s.id === activeSiblingId);
          const variant = sibling
            ? sibling.variants.find(v => v.options.includes(activeSize))
            : null;

          if (variant && variant.available) {
            cardState[cardIndex] = { siblingId: activeSiblingId, variantId: variant.id };
            updateStatus(card, activeSize);
          } else {
            delete cardState[cardIndex];
            updateStatus(card, null);
          }

          updateKitButton(cards, cardState, atcBtn, atcText);
        });
      });

      // Init
      const defaultSibling = siblings[0];
      const defaultSwatch = card.querySelector('[data-kit-swatch]');
      const colorLabel = card.querySelector('[data-kit-selected-color]');
      if (colorLabel && defaultSwatch) colorLabel.textContent = defaultSwatch.title;
      updateSizeAvailability(card, defaultSibling, null);
    });

    // ── Kit ATC click ──────────────────────────────────────────────────────
    if (atcBtn) {
      atcBtn.addEventListener('click', async () => {
        const variantIds = Object.values(cardState).map(s => s.variantId);
        if (variantIds.length !== cards.length) return;

        atcBtn.disabled = true;
        atcBtn.classList.add('btn--loading');
        atcText.textContent = 'Adding...';

        try {
          const items = variantIds.map(id => ({ id, quantity: 1 }));

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });

          if (!res.ok) throw new Error('Cart add failed');

          const addedItems = await res.json();
          const cart = await fetch('/cart.js').then(r => r.json());

          document.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart }
          }));

          document.dispatchEvent(new CustomEvent('cart:item-added', {
            bubbles: true,
            detail: { product: addedItems.items ? addedItems.items[0] : addedItems }
          }));

         // Update cart count in header
          const cartCount = document.querySelector('[data-js-cart-count]');
          if (cartCount) cartCount.textContent = cart.item_count;

          setTimeout(() => {
            atcText.textContent = 'Add to Bag';
            atcBtn.disabled = false;
          }, 2500);

        } catch (err) {
          console.error('SENIQ Kit: add to cart failed', err);
          atcText.textContent = 'Error — try again';
          atcBtn.classList.remove('btn--loading');
          atcBtn.disabled = false;
        }
      });
    }
  }

  // ── Size availability ────────────────────────────────────────────────────

  function updateSizeAvailability(card, sibling, currentSize) {
    if (!sibling) return;
    card.querySelectorAll('[data-size]').forEach(sizeBtn => {
      const size = sizeBtn.dataset.size;
      const match = sibling.variants.find(v => v.options.includes(size));
      if (match && !match.available) {
        sizeBtn.classList.add('is-unavailable');
      } else {
        sizeBtn.classList.remove('is-unavailable');
      }
    });
  }

  // ── Per-card status label ────────────────────────────────────────────────

  function updateStatus(card, selectedSize) {
    const statusEl = card.querySelector('[data-kit-selection-status]');
    if (!statusEl) return;
    statusEl.textContent = selectedSize ? selectedSize : 'Select a size';
    statusEl.classList.toggle('is-selected', !!selectedSize);
  }

  // ── Kit button state ─────────────────────────────────────────────────────

  function updateKitButton(cards, cardState, atcBtn, atcText) {
    if (!atcBtn) return;
    const allSelected = Object.keys(cardState).length === cards.length;
    atcBtn.disabled = !allSelected;
    if (allSelected) {
      atcBtn.removeAttribute('aria-disabled');
    } else {
      atcBtn.setAttribute('aria-disabled', 'true');
    }
  }

  // ── Run ───────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKitCards);
  } else {
    initKitCards();
  }

})();
